/** Real TCards product screenshots — source of truth for device mockups. Do not replace with fabricated UI. */

export const FIELD_TEAM_ASSETS = {
  crmDashboard: '/field-team/crm-dashboard.png',
  crmAiInsights: '/field-team/crm-ai-insights.png',
  mobileDashboard: '/field-team/mobile-dashboard.png',
  mobileProfile: '/field-team/mobile-profile.png',
  mobileAddLead: '/field-team/mobile-add-lead.png',
} as const;
